"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_InputFileLabel = exports.Occ_InputFileContainer = exports.Occ_InputFile = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_InputFileContainer = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding: var(--spacing-none);\n    margin: var(--spacing-none);\n    font-size: var(--font-size-xs);\n    font-family: var(--font-family-primary);\n    cursor: pointer;\n    height: 40px;\n    padding: 8px 5px;\n    position: relative;\n    border-radius: var(--border-radius-sm);\n    border: 1px solid var(--color-primary);\n    width: ", ";\n"])), function (props) {
  if (props.isize === 'small') {
    return '170px';
  } else if (props.isize === 'medium') {
    return '200px';
  } else if (props.isize === 'large') {
    return '250px';
  } else if (props.isize === 'full') {
    return '100%';
  }
});
exports.Occ_InputFileContainer = Occ_InputFileContainer;
var Occ_InputFileLabel = (0, _styledComponents["default"])('label')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    color: var(--color-primary);\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    gap: ", ";\n\n    svg {\n        pointer-events: none;\n    }\n"])), function (props) {
  if (props.isize === 'full') {
    return 'center';
  } else {
    return 'space-evenly';
  }
}, function (props) {
  return props.isize === 'full' ? '16px' : '0';
});
exports.Occ_InputFileLabel = Occ_InputFileLabel;
var Occ_InputFile = (0, _styledComponents["default"])('input')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: none;\n"])));
exports.Occ_InputFile = Occ_InputFile;